<span class="pagination half-width">
  <span id="initial-icon" [ngClass]="{ disabled: pager?.currentPage === 1 }"
    ><a
      class="vertical-align-middle"
      (click)="paginationOfSelectedItem($safeNavigationMigration(pager?.currentPage) - 1)"
      ><svg
        id="pagination-icon"
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.8274 2.88072L12.4999 1.55322L4.99989 9.05322L12.4999 16.5532L13.8274 15.2257L7.65489 9.05322L13.8274 2.88072Z"
          fill="#26478D"
        /></svg></a
  ></span>
  @for (page of pager?.pages; track page) {
    <span
      ><a [ngClass]="{ active: pager?.currentPage === page }" (click)="paginationOfSelectedItem(page)">{{
        page
      }}</a></span
    >
  }
  <span [ngClass]="{ disabled: pager?.currentPage === pager?.totalPages }"
    ><a
      class="vertical-align-middle"
      (click)="paginationOfSelectedItem($safeNavigationMigration(pager?.currentPage) + 1)"
      ><svg
        id="pagination-icon"
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.17236 15.2257L6.49986 16.5532L13.9999 9.05322L6.49986 1.55322L5.17236 2.88072L11.3449 9.05322L5.17236 15.2257Z"
          fill="#26478D"
        />
      </svg> </a
  ></span>
</span>
